/**
 * Identity-check result cache (dependency-free so jwt.js / practiceSwitchReset.js
 * can clear it without an import cycle through apiCall).
 *
 * Holds masked-but-personal data (names, DOB, candidate ids), so it is emptied on
 * create-dialog close, practice switch and logout, and expired entries are evicted
 * on read.
 */
export const IDENTITY_CACHE_TTL_MS = 2 * 60 * 1000;

const cache = new Map(); // key -> { promise, ts }

export const clearIdentityCache = () => cache.clear();

export function readIdentityCache(key, now = Date.now()) {
    const hit = cache.get(key);
    if (!hit) return null;
    if (now - hit.ts >= IDENTITY_CACHE_TTL_MS) {
        cache.delete(key);
        return null;
    }
    return hit;
}

export const writeIdentityCache = (key, promise) => cache.set(key, { promise, ts: Date.now() });
export const deleteIdentityCache = (key) => cache.delete(key);
